import { PropsWithChildren, useCallback, useEffect } from 'react';

import { useAuthStore } from '../store';

const AuthProvider = ({ children }: PropsWithChildren) => {
    const { accessToken, fetchProfile } = useAuthStore();

    useEffect(() => {
        accessToken && fetchMyProfile(accessToken);
    }, []);

    const fetchMyProfile: (token: string) => void = useCallback(
        (token: string) => {
            fetchProfile(token);
        },
        []
    );

    return <>{children}</>;
};

export default AuthProvider;
